import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delivery-report',
  templateUrl: './delivery-report.component.html',
  styleUrls: ['./delivery-report.component.css']
})
export class DeliveryReportComponent implements OnInit {

  public menu_item_id = '103';

  private dp = [];
  branchList = [];
  allStoreList = [];
  storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];

  displayedColumns = ['invoice_no', 'invoice_date', 'cust_name', 'mobile',
    'total', 'paid', 'remain', 'deliver_date', 'branch_name', 'store_name', 'inv_status', 'detail'];  // , 'customer_no'
  displayedColumns1 = ['invoice_no', 'invoice_date', 'cust_name', 'mobile',
    'total', 'paid', 'remain', 'deliver_date', 'branch_name', 'store_name', 'inv_status'];
    
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'status': '2', 'branch_id': '0', 'store_id': '0', 
    'title': 'تقرير التسليم' };

  statusList = [{ 'status': 'all', 'status_name': 'الكل', 'status_name_en': 'All' },
  { 'status': '1', 'status_name': 'تم التسليم', 'status_name_en': 'Delivered' },
  { 'status': '2', 'status_name': 'لم يتم التسليم', 'status_name_en': 'Not Delivered' }];

  Delivery_Report; From_Date; To_Date;
  From_Date_Msg; To_Date_Msg; 

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Delivery_Report').subscribe((res: string) => {
      this.Delivery_Report = res;
    });
    this.model['title'] = this.Delivery_Report;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });

  }

  ngOnInit() {
    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  search() {
    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    let obj = { cmd: 'getDeliveryRep' };

    if (this.model['from_date'] != undefined) {
      obj['from_date'] = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1)
        + "-" + this.model['from_date'].getDate() + ' 00:00:00');
    }

    if (this.model['to_date'] != undefined) {
      obj['to_date'] = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1)
        + "-" + this.model['to_date'].getDate() + ' 23:59:59');
    }

    if (this.model['status'] != 'all')
      obj['status'] = this.model['status'];

    if (this.model['branch_id'] == '0') 
      obj['store_list'] = this.allStoreList;
    else {
      if (this.model['store_id'] != '0')
        obj['store_id'] = this.model['store_id'];
      else {
        let allStoreList = [];
        this.storeList.forEach(element => {
          if (element.store_id != '0')
            allStoreList.push({ 'store_id': element.store_id });
        });
        obj['store_list'] = allStoreList;
      }
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();

    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
      
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2>' + this.Delivery_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
